<script setup lang="ts">
import DarwinButton from '@/uiKit/DarwinButton.vue'
import IconSprite from '@/uiKit/IconSprite.vue'
defineProps<{
  editing: boolean
}>()

defineEmits<{
  cancel: []
  save: []
  edit: []
}>()
</script>

<template>
  <template v-if="editing">
    <div class="flex items-center gap-1">
      <DarwinButton
        size="xs"
        variant="transparent"
        @click="$emit('cancel')"
      >
        <template #leading-icon>
          <IconSprite icon="close" />
        </template>
        Cancel
      </DarwinButton>
      <DarwinButton
        size="xs"
        variant="transparent"
        @click="$emit('save')"
      >
        <template #leading-icon>
          <IconSprite icon="check" />
        </template>
        Save
      </DarwinButton>
    </div>
  </template>
  <DarwinButton
    v-else
    size="xs"
    variant="transparent"
    @click="$emit('edit')"
  >
    <template #leading-icon>
      <IconSprite icon="edit" />
    </template>
    Edit
  </DarwinButton>
</template>
